// Options for the different property types
export const propertiesOptions = [
    { label: "Business Opportunity Property Type", value: "Business Opportunity" },
    { label: "Commercial Lease Property Type", value: "Commercial Lease" },
    { label: "Commercial Sale Property Type", value: "Commercial Sale" },
    { label: "Farm Land Property Type", value: "Farm Land" },
    { label: "Land Property Type", value: "Land" },
    { label: "Mobile Home Property Type", value: "Mobile Home" },
    { label: "Residential Income Property Type", value: "Residential Income" },
    { label: "Residential Lease Property Type", value: "Residential Lease" },
    { label: "Residential Property Type", value: "Residential" },
]

export const propertySubTypeOptions = [
    { displayName: "Co-Ownership", value: "Co-Ownership" },
    { displayName: "Deeded Parking", value: "Deeded Parking" },
    { displayName: "Duplex", value: "Duplex" },
    { displayName: "Manufactured On Land", value: "Manufactured On Land" },
    { displayName: "Mobile Home Park", value: "Mobile Home Park" },
    { displayName: "Multi Family", value: "Multi Family" },
    { displayName: "Own Your Own", value: "Own Your Own" },
    { displayName: "Quadruplex", value: "Quadruplex" },
    { displayName: "Single Family Residence", value: "Single Family Residence" },
    { displayName: "Tenancy in Common", value: "Tenancy in Common" },
    { displayName: "Townhouse", value: "Townhouse" },
    { displayName: "Triplex", value: "Triplex" },
    { displayName: "Unimproved Land", value: "Unimproved Land" },
]

export const patioAndPorchFeaturesOptions = [
    { displayName: "Awning(s)", value: "Awning(s)" },
    { displayName: "Covered", value: "Covered" },
    { displayName: "Deck", value: "Deck" },
    { displayName: "Enclosed", value: "Enclosed" },
    { displayName: "Front Porch", value: "Front Porch" },
    { displayName: "Glass Enclosed", value: "Glass Enclosed" },
    { displayName: "None", value: "None" },
    { displayName: "Other", value: "Other" },
    { displayName: "Patio", value: "Patio" },
    { displayName: "Porch", value: "Porch" },
    { displayName: "Rear Porch", value: "Rear Porch" },
    { displayName: "Screened", value: "Screened" },
    { displayName: "See Remarks", value: "See Remarks" },
    { displayName: "Side Porch", value: "Side Porch" },
    { displayName: "Terrace", value: "Terrace" },
    { displayName: "Wrap Around", value: "Wrap Around" },
]

export const roomTypesOptions = [
    { displayName: "Basement", value: "Basement" },
    { displayName: "Bathroom 1", value: "Bathroom 1" },
    { displayName: "Bathroom 2", value: "Bathroom 2" },
    { displayName: "Bathroom 3", value: "Bathroom 3" },
    { displayName: "Bathroom 4", value: "Bathroom 4" },
    { displayName: "Bathroom 5", value: "Bathroom 5" },
    { displayName: "Bathroom", value: "Bathroom" },
    { displayName: "Bedroom 1", value: "Bedroom 1" },
    { displayName: "Bedroom 2", value: "Bedroom 2" },
    { displayName: "Bedroom 3", value: "Bedroom 3" },
    { displayName: "Bedroom 4", value: "Bedroom 4" },
    { displayName: "Bedroom 5", value: "Bedroom 5" },
    { displayName: "Bedroom", value: "Bedroom" },
    { displayName: "Bonus Room", value: "Bonus Room" },
    { displayName: "Den", value: "Den" },
    { displayName: "Dining Room", value: "Dining Room" },
    { displayName: "Exercise Room", value: "Exercise Room" },
    { displayName: "Family Room", value: "Family Room" },
    { displayName: "Game Room", value: "Game Room" },
    { displayName: "Great Room", value: "Great Room" },
    { displayName: "Gym", value: "Gym" },
    { displayName: "Kitchen", value: "Kitchen" },
    { displayName: "Laundry", value: "Laundry" },
    { displayName: "Library", value: "Library" },
    { displayName: "Living Room", value: "Living Room" },
    { displayName: "Loft", value: "Loft" },
    { displayName: "Master Bathroom", value: "Master Bathroom" },
    { displayName: "Master Bedroom", value: "Master Bedroom" },
    { displayName: "Media Room", value: "Media Room" },
    { displayName: "Office", value: "Office" },
    { displayName: "Sauna", value: "Sauna" },
    { displayName: "Utility Room", value: "Utility Room" },
    { displayName: "Workshop", value: "Workshop" },
]

export const associationFeeIncludesOptions = [
    { displayName: "Cable TV", value: "Cable TV" },
    { displayName: "Earthquake Insurance", value: "Earthquake Insurance" },
    { displayName: "Electricity", value: "Electricity" },
    { displayName: "Gas", value: "Gas" },
    { displayName: "Insurance", value: "Insurance" },
    { displayName: "Internet", value: "Internet" },
    { displayName: "Maintenance Grounds", value: "Maintenance Grounds" },
    { displayName: "Maintenance Structure", value: "Maintenance Structure" },
    { displayName: "Pest Control", value: "Pest Control" },
    { displayName: "Security", value: "Security" },
    { displayName: "Sewer", value: "Sewer" },
    { displayName: "Snow Removal", value: "Snow Removal" },
    { displayName: "Trash", value: "Trash" },
    { displayName: "Utilities", value: "Utilities" },
    { displayName: "Water", value: "Water" },
]

export const appliancesOptions = [
    { displayName: "Bar Fridge", value: "Bar Fridge" },
    { displayName: "Built-In Electric Oven", value: "Built-In Electric Oven" },
    { displayName: "Built-In Electric Range", value: "Built-In Electric Range" },
    { displayName: "Built-In Freezer", value: "Built-In Freezer" },
    { displayName: "Built-In Gas Oven", value: "Built-In Gas Oven" },
    { displayName: "Built-In Gas Range", value: "Built-In Gas Range" },
    { displayName: "Built-In Range", value: "Built-In Range" },
    { displayName: "Built-In Refrigerator", value: "Built-In Refrigerator" },
    { displayName: "Convection Oven", value: "Convection Oven" },
    { displayName: "Cooktop", value: "Cooktop" },
    { displayName: "Dishwasher", value: "Dishwasher" },
    { displayName: "Disposal", value: "Disposal" },
    { displayName: "Double Oven", value: "Double Oven" },
    { displayName: "Down Draft", value: "Down Draft" },
    { displayName: "Dryer", value: "Dryer" },
    { displayName: "Electric Cooktop", value: "Electric Cooktop" },
    { displayName: "Electric Oven", value: "Electric Oven" },
    { displayName: "Electric Range", value: "Electric Range" },
    { displayName: "Electric Water Heater", value: "Electric Water Heater" },
    { displayName: "ENERGY STAR Qualified Appliances", value: "ENERGY STAR Qualified Appliances" },
    { displayName: "ENERGY STAR Qualified Dishwasher", value: "ENERGY STAR Qualified Dishwasher" },
    { displayName: "ENERGY STAR Qualified Dryer", value: "ENERGY STAR Qualified Dryer" },
    { displayName: "ENERGY STAR Qualified Freezer", value: "ENERGY STAR Qualified Freezer" },
    { displayName: "ENERGY STAR Qualified Refrigerator", value: "ENERGY STAR Qualified Refrigerator" },
    { displayName: "ENERGY STAR Qualified Washer", value: "ENERGY STAR Qualified Washer" },
    { displayName: "ENERGY STAR Qualified Water Heater", value: "ENERGY STAR Qualified Water Heater" },
    { displayName: "Exhaust Fan", value: "Exhaust Fan" },
    { displayName: "Free-Standing Electric Oven", value: "Free-Standing Electric Oven" },
    { displayName: "Free-Standing Electric Range", value: "Free-Standing Electric Range" },
    { displayName: "Free-Standing Freezer", value: "Free-Standing Freezer" },
    { displayName: "Free-Standing Gas Oven", value: "Free-Standing Gas Oven" },
    { displayName: "Free-Standing Gas Range", value: "Free-Standing Gas Range" },
    { displayName: "Free-Standing Range", value: "Free-Standing Range" },
    { displayName: "Free-Standing Refrigerator", value: "Free-Standing Refrigerator" },
    { displayName: "Freezer", value: "Freezer" },
    { displayName: "Gas Cooktop", value: "Gas Cooktop" },
    { displayName: "Gas Oven", value: "Gas Oven" },
    { displayName: "Gas Range", value: "Gas Range" },
    { displayName: "Gas Water Heater", value: "Gas Water Heater" },
    { displayName: "Heat Pump Water Heater", value: "Heat Pump Water Heater" },
    { displayName: "Humidifier", value: "Humidifier" },
    { displayName: "Ice Maker", value: "Ice Maker" },
    { displayName: "Indoor Grill", value: "Indoor Grill" },
    { displayName: "Induction Cooktop", value: "Induction Cooktop" },
    { displayName: "Instant Hot Water", value: "Instant Hot Water" },
    { displayName: "Microwave", value: "Microwave" },
    { displayName: "None", value: "None" },
    { displayName: "Other", value: "Other" },
    { displayName: "Oven", value: "Oven" },
    { displayName: "Plumbed For Ice Maker", value: "Plumbed For Ice Maker" },
    { displayName: "Portable Dishwasher", value: "Portable Dishwasher" },
    { displayName: "Propane Cooktop", value: "Propane Cooktop" },
    { displayName: "Range", value: "Range" },
    { displayName: "Range Hood", value: "Range Hood" },
    { displayName: "Refrigerator", value: "Refrigerator" },
    { displayName: "Self Cleaning Oven", value: "Self Cleaning Oven" },
    { displayName: "Smart Appliance(s)", value: "Smart Appliance(s)" },
    { displayName: "Solar Hot Water", value: "Solar Hot Water" },
    { displayName: "Stainless Steel Appliance(s)", value: "Stainless Steel Appliance(s)" },
    { displayName: "Tankless Water Heater", value: "Tankless Water Heater" },
    { displayName: "Trash Compactor", value: "Trash Compactor" },
    { displayName: "Vented Exhaust Fan", value: "Vented Exhaust Fan" },
    { displayName: "Warming Drawer", value: "Warming Drawer" },
    { displayName: "Washer", value: "Washer" },
    { displayName: "Washer/Dryer", value: "Washer/Dryer" },
    { displayName: "Washer/Dryer Stacked", value: "Washer/Dryer Stacked" },
    { displayName: "Water Heater", value: "Water Heater" },
    { displayName: "Water Purifier", value: "Water Purifier" },
    { displayName: "Water Purifier Owned", value: "Water Purifier Owned" },
    { displayName: "Water Purifier Rented", value: "Water Purifier Rented" },
    { displayName: "Water Softener", value: "Water Softener" },
    { displayName: "Water Softener Owned", value: "Water Softener Owned" },
    { displayName: "Water Softener Rented", value: "Water Softener Rented" },
    { displayName: "Wine Cooler", value: "Wine Cooler" },
    { displayName: "Wine Refrigerator", value: "Wine Refrigerator" },
]

export const laundryFeaturesOptions = [
    { displayName: "Common Area", value: "Common Area" },
    { displayName: "Electric Dryer Hookup", value: "Electric Dryer Hookup" },
    { displayName: "Gas Dryer Hookup", value: "Gas Dryer Hookup" },
    { displayName: "In Basement", value: "In Basement" },
    { displayName: "In Bathroom", value: "In Bathroom" },
    { displayName: "In Carport", value: "In Carport" },
    { displayName: "In Garage", value: "In Garage" },
    { displayName: "In Hall", value: "In Hall" },
    { displayName: "In Kitchen", value: "In Kitchen" },
    { displayName: "Inside", value: "Inside" },
    { displayName: "In Unit", value: "In Unit" },
    { displayName: "Laundry Chute", value: "Laundry Chute" },
    { displayName: "Laundry Closet", value: "Laundry Closet" },
    { displayName: "Laundry Room", value: "Laundry Room" },
    { displayName: "Lower Level", value: "Lower Level" },
    { displayName: "Main Level", value: "Main Level" },
    { displayName: "Multiple Locations", value: "Multiple Locations" },
    { displayName: "None", value: "None" },
    { displayName: "Other", value: "Other" },
    { displayName: "Outside", value: "Outside" },
    { displayName: "See Remarks", value: "See Remarks" },
    { displayName: "Sink", value: "Sink" },
    { displayName: "Upper Level", value: "Upper Level" },
    { displayName: "Washer Hookup", value: "Washer Hookup" },
]

// Fireplace Features options for filters
export const fireplaceFeaturesOptions = [
    { displayName: "Basement", value: "Basement" },
    { displayName: "Bath", value: "Bath" },
    { displayName: "Bedroom", value: "Bedroom" },
    { displayName: "Blower Fan", value: "Blower Fan" },
    { displayName: "Circulating", value: "Circulating" },
    { displayName: "Decorative", value: "Decorative" },
    { displayName: "Den", value: "Den" },
    { displayName: "Dining Room", value: "Dining Room" },
    { displayName: "Double Sided", value: "Double Sided" },
    { displayName: "Electric", value: "Electric" },
    { displayName: "EPA Certified Wood Stove", value: "EPA Certified Wood Stove" },
    { displayName: "EPA Qualified Fireplace", value: "EPA Qualified Fireplace" },
    { displayName: "Factory Built", value: "Factory Built" },
    { displayName: "Family Room", value: "Family Room" },
    { displayName: "Fire Pit", value: "Fire Pit" },
    { displayName: "Free Standing", value: "Free Standing" },
    { displayName: "Gas", value: "Gas" },
    { displayName: "Gas Log", value: "Gas Log" },
    { displayName: "Gas Starter", value: "Gas Starter" },
    { displayName: "Glass Doors", value: "Glass Doors" },
    { displayName: "Great Room", value: "Great Room" },
    { displayName: "Heatilator", value: "Heatilator" },
    { displayName: "Insert", value: "Insert" },
    { displayName: "Kitchen", value: "Kitchen" },
    { displayName: "Library", value: "Library" },
    { displayName: "Living Room", value: "Living Room" },
    { displayName: "Masonry", value: "Masonry" },
    { displayName: "Master Bedroom", value: "Master Bedroom" },
    { displayName: "Metal", value: "Metal" },
    { displayName: "None", value: "None" },
    { displayName: "Other", value: "Other" },
    { displayName: "Outside", value: "Outside" },
    { displayName: "Pellet Stove", value: "Pellet Stove" },
    { displayName: "Propane", value: "Propane" },
    { displayName: "Raised Hearth", value: "Raised Hearth" },
    { displayName: "Recreation Room", value: "Recreation Room" },
    { displayName: "Sealed Combustion", value: "Sealed Combustion" },
    { displayName: "See Remarks", value: "See Remarks" },
    { displayName: "See Through", value: "See Through" },
    { displayName: "Stone", value: "Stone" },
    { displayName: "Ventless", value: "Ventless" },
    { displayName: "Wood Burning", value: "Wood Burning" },
    { displayName: "Wood Burning Stove", value: "Wood Burning Stove" },
    { displayName: "Zero Clearance", value: "Zero Clearance" },
]

export const associationFeeFrequencyOptions = [
    { displayName: "Annually", value: "Annually" },
    { displayName: "Bi-Monthly", value: "Bi-Monthly" },
    { displayName: "Bi-Weekly", value: "Bi-Weekly" },
    { displayName: "Daily", value: "Daily" },
    { displayName: "Monthly", value: "Monthly" },
    { displayName: "One Time", value: "One Time" },
    { displayName: "Quarterly", value: "Quarterly" },
    { displayName: "Seasonal", value: "Seasonal" },
    { displayName: "Semi-Annually", value: "Semi-Annually" },
    { displayName: "Semi-Monthly", value: "Semi-Monthly" },
    { displayName: "Weekly", value: "Weekly" },
]

// Flooring Features options for filters
export const flooringOptions = [
    { displayName: "Adobe", value: "Adobe" },
    { displayName: "Bamboo", value: "Bamboo" },
    { displayName: "Brick", value: "Brick" },
    { displayName: "Carpet", value: "Carpet" },
    { displayName: "Ceramic Tile", value: "Ceramic Tile" },
    { displayName: "Clay", value: "Clay" },
    { displayName: "Combination", value: "Combination" },
    { displayName: "Concrete", value: "Concrete" },
    { displayName: "Cork", value: "Cork" },
    { displayName: "CRI Green Label Plus Certified Carpet", value: "CRI Green Label Plus Certified Carpet" },
    { displayName: "Dirt", value: "Dirt" },
    { displayName: "Engineered Hardwood", value: "Engineered Hardwood" },
    { displayName: "FloorScore(r) Certified Flooring", value: "FloorScore(r) Certified Flooring" },
    { displayName: "FSC or SFI Certified Source Hardwood", value: "FSC or SFI Certified Source Hardwood" },
    { displayName: "Granite", value: "Granite" },
    { displayName: "Hardwood", value: "Hardwood" },
    { displayName: "Laminate", value: "Laminate" },
    { displayName: "Linoleum", value: "Linoleum" },
    { displayName: "Luxury Vinyl", value: "Luxury Vinyl" },
    { displayName: "Marble", value: "Marble" },
    { displayName: "None", value: "None" },
    { displayName: "Other", value: "Other" },
    { displayName: "Painted/Stained", value: "Painted/Stained" },
    { displayName: "Parquet", value: "Parquet" },
    { displayName: "Pavers", value: "Pavers" },
    { displayName: "Plank", value: "Plank" },
    { displayName: "Reclaimed Wood", value: "Reclaimed Wood" },
    { displayName: "See Remarks", value: "See Remarks" },
    { displayName: "Simulated Wood", value: "Simulated Wood" },
    { displayName: "Slate", value: "Slate" },
    { displayName: "Softwood", value: "Softwood" },
    { displayName: "Stamped", value: "Stamped" },
    { displayName: "Stone", value: "Stone" },
    { displayName: "Sustainable", value: "Sustainable" },
    { displayName: "Terrazzo", value: "Terrazzo" },
    { displayName: "Tile", value: "Tile" },
    { displayName: "Varies", value: "Varies" },
    { displayName: "Vinyl", value: "Vinyl" },
    { displayName: "Wood", value: "Wood" },
]

// Interior Features options for filters
export const interiorFeaturesOptions = [
    { displayName: "Bar", value: "Bar" },
    { displayName: "Beamed Ceilings", value: "Beamed Ceilings" },
    { displayName: "Bidet", value: "Bidet" },
    { displayName: "Bookcases", value: "Bookcases" },
    { displayName: "Breakfast Bar", value: "Breakfast Bar" },
    { displayName: "Built-in Features", value: "Built-in Features" },
    { displayName: "Cathedral Ceiling(s)", value: "Cathedral Ceiling(s)" },
    { displayName: "Cedar Closet(s)", value: "Cedar Closet(s)" },
    { displayName: "Ceiling Fan(s)", value: "Ceiling Fan(s)" },
    { displayName: "Central Vacuum", value: "Central Vacuum" },
    { displayName: "Chandelier", value: "Chandelier" },
    { displayName: "Coffered Ceiling(s)", value: "Coffered Ceiling(s)" },
    { displayName: "Crown Molding", value: "Crown Molding" },
    { displayName: "Double Vanity", value: "Double Vanity" },
    { displayName: "Dry Bar", value: "Dry Bar" },
    { displayName: "Dumbwaiter", value: "Dumbwaiter" },
    { displayName: "Eat-in Kitchen", value: "Eat-in Kitchen" },
    { displayName: "Elevator", value: "Elevator" },
    { displayName: "Entrance Foyer", value: "Entrance Foyer" },
    { displayName: "Granite Counters", value: "Granite Counters" },
    { displayName: "High Ceilings", value: "High Ceilings" },
    { displayName: "High Speed Internet", value: "High Speed Internet" },
    { displayName: "His and Hers Closets", value: "His and Hers Closets" },
    { displayName: "In-Law Floorplan", value: "In-Law Floorplan" },
    { displayName: "Kitchen Island", value: "Kitchen Island" },
    { displayName: "Laminate Counters", value: "Laminate Counters" },
    { displayName: "Low Flow Plumbing Fixtures", value: "Low Flow Plumbing Fixtures" },
    { displayName: "Master Downstairs", value: "Master Downstairs" },
    { displayName: "Natural Woodwork", value: "Natural Woodwork" },
    { displayName: "Open Floorplan", value: "Open Floorplan" },
    { displayName: "Other", value: "Other" },
    { displayName: "Pantry", value: "Pantry" },
    { displayName: "Recessed Lighting", value: "Recessed Lighting" },
    { displayName: "Sauna", value: "Sauna" },
    { displayName: "See Remarks", value: "See Remarks" },
    {
        displayName: "Smart Camera(s)/Recording",
        value: "Smart Camera(s)/Recording",
    },
    { displayName: "Smart Home", value: "Smart Home" },
    { displayName: "Smart Light(s)", value: "Smart Light(s)" },
    { displayName: "Smart Thermostat", value: "Smart Thermostat" },
    { displayName: "Soaking Tub", value: "Soaking Tub" },
    { displayName: "Solar Tube(s)", value: "Solar Tube(s)" },
    { displayName: "Sound System", value: "Sound System" },
    { displayName: "Stone Counters", value: "Stone Counters" },
    { displayName: "Storage", value: "Storage" },
    { displayName: "Tile Counters", value: "Tile Counters" },
    { displayName: "Track Lighting", value: "Track Lighting" },
    { displayName: "Tray Ceiling(s)", value: "Tray Ceiling(s)" },
    { displayName: "Vaulted Ceiling(s)", value: "Vaulted Ceiling(s)" },
    { displayName: "Walk-In Closet(s)", value: "Walk-In Closet(s)" },
    { displayName: "WaterSense Fixture(s)", value: "WaterSense Fixture(s)" },
    { displayName: "Wet Bar", value: "Wet Bar" },
    { displayName: "Wired for Data", value: "Wired for Data" },
    { displayName: "Wired for Sound", value: "Wired for Sound" },
]

// Window Features options for filters
export const windowFeaturesOptions = [
    { displayName: "Aluminum Frames", value: "Aluminum Frames" },
    { displayName: "Bay Window(s)", value: "Bay Window(s)" },
    { displayName: "Blinds", value: "Blinds" },
    { displayName: "Display Window(s)", value: "Display Window(s)" },
    { displayName: "Double Pane Windows", value: "Double Pane Windows" },
    { displayName: "Drapes", value: "Drapes" },
    { displayName: "ENERGY STAR Qualified Windows", value: "ENERGY STAR Qualified Windows" },
    { displayName: "Garden Window(s)", value: "Garden Window(s)" },
    { displayName: "Insulated Windows", value: "Insulated Windows" },
    { displayName: "Low-Emissivity Windows", value: "Low-Emissivity Windows" },
    { displayName: "Plantation Shutters", value: "Plantation Shutters" },
    { displayName: "Screens", value: "Screens" },
    { displayName: "Shutters", value: "Shutters" },
    { displayName: "Skylight(s)", value: "Skylight(s)" },
    { displayName: "Solar Screens", value: "Solar Screens" },
    { displayName: "Storm Window(s)", value: "Storm Window(s)" },
    { displayName: "Tinted Windows", value: "Tinted Windows" },
    { displayName: "Triple Pane Windows", value: "Triple Pane Windows" },
    { displayName: "Window Coverings", value: "Window Coverings" },
    { displayName: "Window Treatments", value: "Window Treatments" },
    { displayName: "Wood Frames", value: "Wood Frames" },
]

// Living Area Source options for filters
export const livingAreaSourceOptions = [
    { displayName: "Appraiser", value: "Appraiser" },
    { displayName: "Assessor", value: "Assessor" },
    { displayName: "Builder", value: "Builder" },
    { displayName: "Estimated", value: "Estimated" },
    { displayName: "Other", value: "Other" },
    { displayName: "Owner", value: "Owner" },
    { displayName: "Plans", value: "Plans" },
    { displayName: "Public Records", value: "Public Records" },
    { displayName: "See Remarks", value: "See Remarks" },
]

// Heating Features options for filters
export const heatingOptions = [
    { displayName: "Active Solar", value: "Active Solar" },
    { displayName: "Baseboard", value: "Baseboard" },
    { displayName: "Ceiling", value: "Ceiling" },
    { displayName: "Central", value: "Central" },
    { displayName: "Coal", value: "Coal" },
    { displayName: "Coal Stove", value: "Coal Stove" },
    { displayName: "Ductless", value: "Ductless" },
    { displayName: "Electric", value: "Electric" },
    {
        displayName: "ENERGY STAR/ACCA RSI Qualified Installation",
        value: "ENERGY STAR/ACCA RSI Qualified Installation",
    },
    { displayName: "ENERGY STAR Qualified Equipment", value: "ENERGY STAR Qualified Equipment" },
    { displayName: "Exhaust Fan", value: "Exhaust Fan" },
    { displayName: "Fireplace(s)", value: "Fireplace(s)" },
    { displayName: "Fireplace Insert", value: "Fireplace Insert" },
    { displayName: "Floor Furnace", value: "Floor Furnace" },
    { displayName: "Forced Air", value: "Forced Air" },
    { displayName: "Geothermal", value: "Geothermal" },
    { displayName: "Gravity", value: "Gravity" },
    { displayName: "Heat Pump", value: "Heat Pump" },
    { displayName: "Hot Water", value: "Hot Water" },
    { displayName: "Humidity Control", value: "Humidity Control" },
    { displayName: "Kerosene", value: "Kerosene" },
    { displayName: "Natural Gas", value: "Natural Gas" },
    { displayName: "None", value: "None" },
    { displayName: "Oil", value: "Oil" },
    { displayName: "Other", value: "Other" },
    { displayName: "Passive Solar", value: "Passive Solar" },
    { displayName: "Pellet Stove", value: "Pellet Stove" },
    { displayName: "Propane", value: "Propane" },
    { displayName: "Propane Stove", value: "Propane Stove" },
    { displayName: "Radiant", value: "Radiant" },
    { displayName: "Radiant Ceiling", value: "Radiant Ceiling" },
    { displayName: "Radiant Floor", value: "Radiant Floor" },
    { displayName: "See Remarks", value: "See Remarks" },
    { displayName: "Separate Meters", value: "Separate Meters" },
    { displayName: "Solar", value: "Solar" },
    { displayName: "Space Heater", value: "Space Heater" },
    { displayName: "Steam", value: "Steam" },
    { displayName: "Varies by Unit", value: "Varies by Unit" },
    { displayName: "Wall Furnace", value: "Wall Furnace" },
    { displayName: "Wood", value: "Wood" },
    { displayName: "Wood Stove", value: "Wood Stove" },
    { displayName: "Zoned", value: "Zoned" },
]

// Cooling Features options for filters
export const coolingOptions = [
    { displayName: "Attic Fan", value: "Attic Fan" },
    { displayName: "Ceiling Fan(s)", value: "Ceiling Fan(s)" },
    { displayName: "Central Air", value: "Central Air" },
    { displayName: "Dual", value: "Dual" },
    { displayName: "Ductless", value: "Ductless" },
    { displayName: "Electric", value: "Electric" },
    { displayName: "ENERGY STAR Qualified Equipment", value: "ENERGY STAR Qualified Equipment" },
    { displayName: "Evaporative Cooling", value: "Evaporative Cooling" },
    { displayName: "Exhaust Fan", value: "Exhaust Fan" },
    { displayName: "Gas", value: "Gas" },
    { displayName: "Geothermal", value: "Geothermal" },
    { displayName: "Heat Pump", value: "Heat Pump" },
    { displayName: "Humidity Control", value: "Humidity Control" },
    { displayName: "Multi Units", value: "Multi Units" },
    { displayName: "None", value: "None" },
    { displayName: "Other", value: "Other" },
    { displayName: "Roof Turbine(s)", value: "Roof Turbine(s)" },
    { displayName: "Separate Meters", value: "Separate Meters" },
    { displayName: "Varies by Unit", value: "Varies by Unit" },
    { displayName: "Wall/Window Unit(s)", value: "Wall/Window Unit(s)" },
    { displayName: "Wall Unit(s)", value: "Wall Unit(s)" },
    { displayName: "Whole House Fan", value: "Whole House Fan" },
    { displayName: "Window Unit(s)", value: "Window Unit(s)" },
    { displayName: "Zoned", value: "Zoned" },
]

// Property Room Features options for filters
export const propertyRoomFeaturesOptions = [
    { displayName: "Bar", value: "Bar" },
    { displayName: "Beamed Ceilings", value: "Beamed Ceilings" },
    { displayName: "Bidet", value: "Bidet" },
    { displayName: "Bookcases", value: "Bookcases" },
    { displayName: "Breakfast Bar", value: "Breakfast Bar" },
    { displayName: "Built-in Features", value: "Built-in Features" },
    { displayName: "Cathedral Ceiling(s)", value: "Cathedral Ceiling(s)" },
    { displayName: "Cedar Closet(s)", value: "Cedar Closet(s)" },
    { displayName: "Ceiling Fan(s)", value: "Ceiling Fan(s)" },
    { displayName: "Central Vacuum", value: "Central Vacuum" },
    { displayName: "Chandelier", value: "Chandelier" },
    { displayName: "Coffered Ceiling(s)", value: "Coffered Ceiling(s)" },
    { displayName: "Crown Molding", value: "Crown Molding" },
    { displayName: "Double Vanity", value: "Double Vanity" },
    { displayName: "Dry Bar", value: "Dry Bar" },
    { displayName: "Dumbwaiter", value: "Dumbwaiter" },
    { displayName: "Eat-in Kitchen", value: "Eat-in Kitchen" },
    { displayName: "Elevator", value: "Elevator" },
    { displayName: "Entrance Foyer", value: "Entrance Foyer" },
    { displayName: "Granite Counters", value: "Granite Counters" },
    { displayName: "High Ceilings", value: "High Ceilings" },
    { displayName: "High Speed Internet", value: "High Speed Internet" },
    { displayName: "His and Hers Closets", value: "His and Hers Closets" },
    { displayName: "In-Law Floorplan", value: "In-Law Floorplan" },
    { displayName: "Kitchen Island", value: "Kitchen Island" },
    { displayName: "Laminate Counters", value: "Laminate Counters" },
    { displayName: "Low Flow Plumbing Fixtures", value: "Low Flow Plumbing Fixtures" },
    { displayName: "Master Downstairs", value: "Master Downstairs" },
    { displayName: "Natural Woodwork", value: "Natural Woodwork" },
    { displayName: "Open Floorplan", value: "Open Floorplan" },
    { displayName: "Other", value: "Other" },
    { displayName: "Pantry", value: "Pantry" },
    { displayName: "Recessed Lighting", value: "Recessed Lighting" },
    { displayName: "Sauna", value: "Sauna" },
    { displayName: "See Remarks", value: "See Remarks" },
    {
        displayName: "Smart Camera(s)/Recording",
        value: "Smart Camera(s)/Recording",
    },
    { displayName: "Smart Home", value: "Smart Home" },
    { displayName: "Smart Light(s)", value: "Smart Light(s)" },
    { displayName: "Smart Thermostat", value: "Smart Thermostat" },
    { displayName: "Soaking Tub", value: "Soaking Tub" },
    { displayName: "Solar Tube(s)", value: "Solar Tube(s)" },
    { displayName: "Sound System", value: "Sound System" },
    { displayName: "Stone Counters", value: "Stone Counters" },
    { displayName: "Storage", value: "Storage" },
    { displayName: "Tile Counters", value: "Tile Counters" },
    { displayName: "Track Lighting", value: "Track Lighting" },
    { displayName: "Tray Ceiling(s)", value: "Tray Ceiling(s)" },
    { displayName: "Vaulted Ceiling(s)", value: "Vaulted Ceiling(s)" },
    { displayName: "Walk-In Closet(s)", value: "Walk-In Closet(s)" },
    { displayName: "WaterSense Fixture(s)", value: "WaterSense Fixture(s)" },
    { displayName: "Wet Bar", value: "Wet Bar" },
    { displayName: "Wired for Data", value: "Wired for Data" },
    { displayName: "Wired for Sound", value: "Wired for Sound" },
]

// Exterior Features options for filters
export const exteriorFeaturesOptions = [
    { displayName: "Awning(s)", value: "Awning(s)" },
    { displayName: "Balcony", value: "Balcony" },
    { displayName: "Barbecue", value: "Barbecue" },
    { displayName: "Basketball Court", value: "Basketball Court" },
    { displayName: "Boat Slip", value: "Boat Slip" },
    { displayName: "Built-in Barbecue", value: "Built-in Barbecue" },
    { displayName: "Courtyard", value: "Courtyard" },
    { displayName: "Covered Courtyard", value: "Covered Courtyard" },
    { displayName: "Dock", value: "Dock" },
    { displayName: "Dog Run", value: "Dog Run" },
    { displayName: "Electric Grill", value: "Electric Grill" },
    { displayName: "Fire Pit", value: "Fire Pit" },
    { displayName: "Garden", value: "Garden" },
    { displayName: "Gas Grill", value: "Gas Grill" },
    { displayName: "Gray Water System", value: "Gray Water System" },
    { displayName: "Kennel", value: "Kennel" },
    { displayName: "Lighting", value: "Lighting" },
    { displayName: "Misting System", value: "Misting System" },
    { displayName: "None", value: "None" },
    { displayName: "Other", value: "Other" },
    { displayName: "Outdoor Grill", value: "Outdoor Grill" },
    { displayName: "Outdoor Kitchen", value: "Outdoor Kitchen" },
    { displayName: "Outdoor Shower", value: "Outdoor Shower" },
    { displayName: "Permeable Paving", value: "Permeable Paving" },
    { displayName: "Playground", value: "Playground" },
    { displayName: "Private Entrance", value: "Private Entrance" },
    { displayName: "Private Yard", value: "Private Yard" },
    { displayName: "Rain Barrel/Cistern(s)", value: "Rain Barrel/Cistern(s)" },
    { displayName: "Rain Gutters", value: "Rain Gutters" },
    { displayName: "RV Hookup", value: "RV Hookup" },
    { displayName: "Smart Camera(s)/Recording", value: "Smart Camera(s)/Recording" },
    { displayName: "Smart Irrigation", value: "Smart Irrigation" },
    { displayName: "Smart Light(s)", value: "Smart Light(s)" },
    { displayName: "Smart Lock(s)", value: "Smart Lock(s)" },
    { displayName: "Storage", value: "Storage" },
    { displayName: "Tennis Court(s)", value: "Tennis Court(s)" },
    { displayName: "Uncovered Courtyard", value: "Uncovered Courtyard" },
]

// Fencing options for filters
export const fencingOptions = [
    { displayName: "Back Yard", value: "Back Yard" },
    { displayName: "Barbed Wire", value: "Barbed Wire" },
    { displayName: "Block", value: "Block" },
    { displayName: "Brick", value: "Brick" },
    { displayName: "Chain Link", value: "Chain Link" },
    { displayName: "Cross Fenced", value: "Cross Fenced" },
    { displayName: "Electric", value: "Electric" },
    { displayName: "Fenced", value: "Fenced" },
    { displayName: "Front Yard", value: "Front Yard" },
    { displayName: "Full", value: "Full" },
    { displayName: "Gate", value: "Gate" },
    { displayName: "Invisible", value: "Invisible" },
    { displayName: "Masonry", value: "Masonry" },
    { displayName: "None", value: "None" },
    { displayName: "Other", value: "Other" },
    { displayName: "Partial", value: "Partial" },
    { displayName: "Partial Cross", value: "Partial Cross" },
    { displayName: "Perimeter", value: "Perimeter" },
    { displayName: "Pipe", value: "Pipe" },
    { displayName: "Privacy", value: "Privacy" },
    { displayName: "Security", value: "Security" },
    { displayName: "See Remarks", value: "See Remarks" },
    { displayName: "Slump Stone", value: "Slump Stone" },
    { displayName: "Split Rail", value: "Split Rail" },
    { displayName: "Stone", value: "Stone" },
    { displayName: "Vinyl", value: "Vinyl" },
    { displayName: "Wire", value: "Wire" },
    { displayName: "Wood", value: "Wood" },
    { displayName: "Wrought Iron", value: "Wrought Iron" },
]

// Horse Amenities options for filters
export const horseAmenitiesOptions = [
    { displayName: "Arena", value: "Arena" },
    { displayName: "Barn", value: "Barn" },
    { displayName: "Boarding Facilities", value: "Boarding Facilities" },
    { displayName: "Corral(s)", value: "Corral(s)" },
    { displayName: "Hay Storage", value: "Hay Storage" },
    { displayName: "None (HorseAmenities)", value: "None (HorseAmenities)" },
    { displayName: "Other (HorseAmenities)", value: "Other (HorseAmenities)" },
    { displayName: "Paddocks", value: "Paddocks" },
    { displayName: "Palpation Chute", value: "Palpation Chute" },
    { displayName: "Pasture (HorseAmenities)", value: "Pasture (HorseAmenities)" },
    { displayName: "Riding Trail", value: "Riding Trail" },
    { displayName: "Round Pen", value: "Round Pen" },
    { displayName: "See Remarks (HorseAmenities)", value: "See Remarks (HorseAmenities)" },
    { displayName: "Shaving Bin", value: "Shaving Bin" },
    { displayName: "Stable(s) (HorseAmenities)", value: "Stable(s) (HorseAmenities)" },
    { displayName: "Tack Room", value: "Tack Room" },
    { displayName: "Trailer Storage", value: "Trailer Storage" },
    { displayName: "Wash Rack", value: "Wash Rack" },
]

export const leaseTermOptions = [
    { displayName: "6 Months", value: "6 Months" },
    { displayName: "12 Months", value: "12 Months" },
    { displayName: "24 Months", value: "24 Months" },
    { displayName: "Month To Month", value: "Month To Month" },
    { displayName: "Negotiable", value: "Negotiable" },
    { displayName: "None", value: "None" },
    { displayName: "Other", value: "Other" },
    { displayName: "Renewal Option", value: "Renewal Option" },
    { displayName: "Short Term Lease", value: "Short Term Lease" },
    { displayName: "Weekly", value: "Weekly" },
]

export const securityFeaturesOptions = [
    { displayName: "24 Hour Security", value: "24 Hour Security" },
    { displayName: "Building Security", value: "Building Security" },
    { displayName: "Carbon Monoxide Detector(s)", value: "Carbon Monoxide Detector(s)" },
    { displayName: "Closed Circuit Camera(s)", value: "Closed Circuit Camera(s)" },
    { displayName: "Fire Alarm", value: "Fire Alarm" },
    { displayName: "Fire Escape", value: "Fire Escape" },
    { displayName: "Fire Sprinkler System", value: "Fire Sprinkler System" },
    { displayName: "Firewall(s)", value: "Firewall(s)" },
    { displayName: "Gated Community", value: "Gated Community" },
    { displayName: "Gated with Guard", value: "Gated with Guard" },
    { displayName: "Key Card Entry", value: "Key Card Entry" },
    { displayName: "Other", value: "Other" },
    { displayName: "Panic Alarm", value: "Panic Alarm" },
    { displayName: "Prewired", value: "Prewired" },
    { displayName: "Secured Garage/Parking", value: "Secured Garage/Parking" },
    { displayName: "Security Fence", value: "Security Fence" },
    { displayName: "Security Gate", value: "Security Gate" },
    { displayName: "Security Guard", value: "Security Guard" },
    { displayName: "Security Lights", value: "Security Lights" },
    { displayName: "Security Service", value: "Security Service" },
    { displayName: "Security System", value: "Security System" },
    { displayName: "Security System Leased", value: "Security System Leased" },
    { displayName: "Security System Owned", value: "Security System Owned" },
    { displayName: "See Remarks", value: "See Remarks" },
    { displayName: "Smoke Detector(s)", value: "Smoke Detector(s)" },
    { displayName: "Varies By Unit", value: "Varies By Unit" },
    { displayName: "Window Bars", value: "Window Bars" },
    { displayName: "Window Bars with Quick Release", value: "Window Bars with Quick Release" },
]

export const spaFeaturesOptions = [
    { displayName: "Above Ground", value: "Above Ground" },
    { displayName: "Bath", value: "Bath" },
    { displayName: "Community", value: "Community" },
    { displayName: "Fiberglass", value: "Fiberglass" },
    { displayName: "Gunite", value: "Gunite" },
    { displayName: "Heated", value: "Heated" },
    { displayName: "In Ground", value: "In Ground" },
    { displayName: "None", value: "None" },
    { displayName: "Private", value: "Private" },
    { displayName: "See Remarks", value: "See Remarks" },
]

export const parkingFeaturesOptions = [
    { displayName: "Additional Parking", value: "Additional Parking" },
    { displayName: "Aggregate", value: "Aggregate" },
    { displayName: "Alley Access", value: "Alley Access" },
    { displayName: "Asphalt", value: "Asphalt" },
    { displayName: "Assigned", value: "Assigned" },
    { displayName: "Attached", value: "Attached" },
    { displayName: "Attached Carport", value: "Attached Carport" },
    { displayName: "Basement", value: "Basement" },
    { displayName: "Boat", value: "Boat" },
    { displayName: "Carport", value: "Carport" },
    { displayName: "Circular Driveway", value: "Circular Driveway" },
    { displayName: "Common", value: "Common" },
    { displayName: "Community Structure", value: "Community Structure" },
    { displayName: "Concrete", value: "Concrete" },
    { displayName: "Converted Garage", value: "Converted Garage" },
    { displayName: "Covered", value: "Covered" },
    { displayName: "Deck", value: "Deck" },
    { displayName: "Deeded", value: "Deeded" },
    { displayName: "Detached", value: "Detached" },
    { displayName: "Detached Carport", value: "Detached Carport" },
    { displayName: "Direct Access", value: "Direct Access" },
    { displayName: "Drive Through", value: "Drive Through" },
    { displayName: "Driveway", value: "Driveway" },
    { displayName: "Electric Gate", value: "Electric Gate" },
    { displayName: "Electric Vehicle Charging Station(s)", value: "Electric Vehicle Charging Station(s)" },
    { displayName: "Enclosed", value: "Enclosed" },
    { displayName: "Garage", value: "Garage" },
    { displayName: "Garage Door Opener", value: "Garage Door Opener" },
    { displayName: "Garage Faces Front", value: "Garage Faces Front" },
    { displayName: "Garage Faces Rear", value: "Garage Faces Rear" },
    { displayName: "Garage Faces Side", value: "Garage Faces Side" },
    { displayName: "Gated", value: "Gated" },
    { displayName: "Golf Cart Garage", value: "Golf Cart Garage" },
    { displayName: "Gravel", value: "Gravel" },
    { displayName: "Guest", value: "Guest" },
    { displayName: "Heated Garage", value: "Heated Garage" },
    { displayName: "Inside Entrance", value: "Inside Entrance" },
    { displayName: "Kitchen Level", value: "Kitchen Level" },
    { displayName: "Leased", value: "Leased" },
    { displayName: "Lighted", value: "Lighted" },
    { displayName: "No Garage", value: "No Garage" },
    { displayName: "None", value: "None" },
    { displayName: "Off Site", value: "Off Site" },
    { displayName: "Off Street", value: "Off Street" },
    { displayName: "On Site", value: "On Site" },
    { displayName: "On Street", value: "On Street" },
    { displayName: "Open", value: "Open" },
    { displayName: "Other", value: "Other" },
    { displayName: "Outside", value: "Outside" },
    { displayName: "Oversized", value: "Oversized" },
    { displayName: "Parking Lot", value: "Parking Lot" },
    { displayName: "Parking Pad", value: "Parking Pad" },
    { displayName: "Paved", value: "Paved" },
    { displayName: "Paver Block", value: "Paver Block" },
    { displayName: "Permit Required", value: "Permit Required" },
    { displayName: "Private", value: "Private" },
    { displayName: "RV Access/Parking", value: "RV Access/Parking" },
    { displayName: "RV Carport", value: "RV Carport" },
    { displayName: "RV Garage", value: "RV Garage" },
    { displayName: "RV Gated", value: "RV Gated" },
    { displayName: "Secured", value: "Secured" },
    { displayName: "See Remarks", value: "See Remarks" },
    { displayName: "Shared Driveway", value: "Shared Driveway" },
    { displayName: "Side By Side", value: "Side By Side" },
    { displayName: "Storage", value: "Storage" },
    { displayName: "Tandem", value: "Tandem" },
    { displayName: "Unassigned", value: "Unassigned" },
    { displayName: "Underground", value: "Underground" },
    { displayName: "Unpaved", value: "Unpaved" },
    { displayName: "Valet", value: "Valet" },
    { displayName: "Varies by Unit", value: "Varies by Unit" },
    { displayName: "Workshop in Garage", value: "Workshop in Garage" },
]

export const viewOptions = [
    { displayName: "Bay", value: "Bay" },
    { displayName: "Beach", value: "Beach" },
    { displayName: "Bridge(s)", value: "Bridge(s)" },
    { displayName: "Canal", value: "Canal" },
    { displayName: "Canyon", value: "Canyon" },
    { displayName: "City", value: "City" },
    { displayName: "City Lights", value: "City Lights" },
    { displayName: "Creek/Stream", value: "Creek/Stream" },
    { displayName: "Desert", value: "Desert" },
    { displayName: "Downtown", value: "Downtown" },
    { displayName: "Forest", value: "Forest" },
    { displayName: "Garden", value: "Garden" },
    { displayName: "Golf Course", value: "Golf Course" },
    { displayName: "Hills", value: "Hills" },
    { displayName: "Lake", value: "Lake" },
    { displayName: "Marina", value: "Marina" },
    { displayName: "Meadow", value: "Meadow" },
    { displayName: "Mountain(s)", value: "Mountain(s)" },
    { displayName: "Neighborhood", value: "Neighborhood" },
    { displayName: "None", value: "None" },
    { displayName: "Ocean", value: "Ocean" },
    { displayName: "Orchard", value: "Orchard" },
    { displayName: "Other", value: "Other" },
    { displayName: "Panoramic", value: "Panoramic" },
    { displayName: "Park/Greenbelt", value: "Park/Greenbelt" },
    { displayName: "Pasture", value: "Pasture" },
    { displayName: "Pond", value: "Pond" },
    { displayName: "Pool", value: "Pool" },
    { displayName: "Ridge", value: "Ridge" },
    { displayName: "River", value: "River" },
    { displayName: "Rural", value: "Rural" },
    { displayName: "See Remarks", value: "See Remarks" },
    { displayName: "Skyline", value: "Skyline" },
    { displayName: "Territorial", value: "Territorial" },
    { displayName: "Trees/Woods", value: "Trees/Woods" },
    { displayName: "Valley", value: "Valley" },
    { displayName: "Vineyard", value: "Vineyard" },
    { displayName: "Water", value: "Water" },
]

export const waterfrontFeaturesOptions = [
    { displayName: "Bay Access", value: "Bay Access" },
    { displayName: "Bayfront", value: "Bayfront" },
    { displayName: "Beach Access", value: "Beach Access" },
    { displayName: "Beach Front", value: "Beach Front" },
    { displayName: "Canal Access", value: "Canal Access" },
    { displayName: "Canal Front", value: "Canal Front" },
    { displayName: "Creek", value: "Creek" },
    { displayName: "Lagoon", value: "Lagoon" },
    { displayName: "Lake Front", value: "Lake Front" },
    { displayName: "Lake Privileges", value: "Lake Privileges" },
    { displayName: "Marina in Community", value: "Marina in Community" },
    { displayName: "Navigable Water", value: "Navigable Water" },
    { displayName: "Ocean Access", value: "Ocean Access" },
    { displayName: "Ocean Front", value: "Ocean Front" },
    { displayName: "Pond", value: "Pond" },
    { displayName: "River Access", value: "River Access" },
    { displayName: "River Front", value: "River Front" },
    { displayName: "Seawall", value: "Seawall" },
    { displayName: "Stream", value: "Stream" },
    { displayName: "Waterfront", value: "Waterfront" },
]

export const lotFeaturesOptions = [
    { displayName: "Agricultural", value: "Agricultural" },
    { displayName: "Back Yard", value: "Back Yard" },
    { displayName: "Bluff", value: "Bluff" },
    { displayName: "City Lot", value: "City Lot" },
    { displayName: "Cleared", value: "Cleared" },
    { displayName: "Close to Clubhouse", value: "Close to Clubhouse" },
    { displayName: "Corner Lot", value: "Corner Lot" },
    { displayName: "Corners Marked", value: "Corners Marked" },
    { displayName: "Cul-De-Sac", value: "Cul-De-Sac" },
    { displayName: "Desert Back", value: "Desert Back" },
    { displayName: "Desert Front", value: "Desert Front" },
    { displayName: "Farm", value: "Farm" },
    { displayName: "Few Trees", value: "Few Trees" },
    { displayName: "Flag Lot", value: "Flag Lot" },
    { displayName: "Front Yard", value: "Front Yard" },
    { displayName: "Garden", value: "Garden" },
    { displayName: "Gentle Sloping", value: "Gentle Sloping" },
    { displayName: "Greenbelt", value: "Greenbelt" },
    { displayName: "Interior Lot", value: "Interior Lot" },
    { displayName: "Irregular Lot", value: "Irregular Lot" },
    { displayName: "Lake on Lot", value: "Lake on Lot" },
    { displayName: "Landscaped", value: "Landscaped" },
    { displayName: "Level", value: "Level" },
    { displayName: "Many Trees", value: "Many Trees" },
    { displayName: "Meadow", value: "Meadow" },
    { displayName: "Native Plants", value: "Native Plants" },
    { displayName: "Near Golf Course", value: "Near Golf Course" },
    { displayName: "Near Public Transit", value: "Near Public Transit" },
    { displayName: "On Golf Course", value: "On Golf Course" },
    { displayName: "Open Lot", value: "Open Lot" },
    { displayName: "Orchard(s)", value: "Orchard(s)" },
    { displayName: "Other", value: "Other" },
    { displayName: "Pasture", value: "Pasture" },
    { displayName: "Paved", value: "Paved" },
    { displayName: "Pie Shaped Lot", value: "Pie Shaped Lot" },
    { displayName: "Pond on Lot", value: "Pond on Lot" },
    { displayName: "Private", value: "Private" },
    { displayName: "Rectangular Lot", value: "Rectangular Lot" },
    { displayName: "Rock Outcropping", value: "Rock Outcropping" },
    { displayName: "Rolling Slope", value: "Rolling Slope" },
    { displayName: "Secluded", value: "Secluded" },
    { displayName: "See Remarks", value: "See Remarks" },
    { displayName: "Sloped", value: "Sloped" },
    { displayName: "Sloped Down", value: "Sloped Down" },
    { displayName: "Sloped Up", value: "Sloped Up" },
    { displayName: "Split Possible", value: "Split Possible" },
    { displayName: "Sprinklers In Front", value: "Sprinklers In Front" },
    { displayName: "Sprinklers In Rear", value: "Sprinklers In Rear" },
    { displayName: "Steep Slope", value: "Steep Slope" },
    { displayName: "Subdivided", value: "Subdivided" },
    { displayName: "Views", value: "Views" },
    { displayName: "Waterfall", value: "Waterfall" },
    { displayName: "Waterfront", value: "Waterfront" },
    { displayName: "Wetlands", value: "Wetlands" },
    { displayName: "Wooded", value: "Wooded" },
    { displayName: "Zero Lot Line", value: "Zero Lot Line" },
]
export const frontageTypeOptions = [
    { displayName: "Bay/Harbor", value: "Bay/Harbor" },
    { displayName: "Golf Course", value: "Golf Course" },
    { displayName: "Lagoon/Estuary", value: "Lagoon/Estuary" },
    { displayName: "Lakefront", value: "Lakefront" },
    { displayName: "Oceanfront", value: "Oceanfront" },
    { displayName: "Other", value: "Other" },
    { displayName: "River", value: "River" },
    { displayName: "See Remarks", value: "See Remarks" },
    { displayName: "Waterfront", value: "Waterfront" },
]
export const basementOptions = [
    { displayName: "Apartment", value: "Apartment" },
    { displayName: "Bath/Stubbed", value: "Bath/Stubbed" },
    { displayName: "Block", value: "Block" },
    { displayName: "Concrete", value: "Concrete" },
    { displayName: "Crawl Space", value: "Crawl Space" },
    { displayName: "Daylight", value: "Daylight" },
    { displayName: "Dirt Floor", value: "Dirt Floor" },
    { displayName: "Exterior Entry", value: "Exterior Entry" },
    { displayName: "Finished", value: "Finished" },
    { displayName: "French Drain", value: "French Drain" },
    { displayName: "Full", value: "Full" },
    { displayName: "Full Exposure", value: "Full Exposure" },
    { displayName: "Interior Entry", value: "Interior Entry" },
    { displayName: "No Exposure", value: "No Exposure" },
    { displayName: "None", value: "None" },
    { displayName: "Other", value: "Other" },
    { displayName: "Partial", value: "Partial" },
    { displayName: "Partial Exposure", value: "Partial Exposure" },
    { displayName: "Partially Finished", value: "Partially Finished" },
    { displayName: "Storage Space", value: "Storage Space" },
    { displayName: "Sump Pump", value: "Sump Pump" },
    { displayName: "Unfinished", value: "Unfinished" },
    { displayName: "Walk-Out Access", value: "Walk-Out Access" },
    { displayName: "Walk-Up Access", value: "Walk-Up Access" },
]
export const belowGradeFinishedAreaUnitsOptions = [
    { displayName: "Square Feet", value: "Square Feet" },
    { displayName: "Square Meters", value: "Square Meters" },
]

export const belowGradeFinishedAreaSourceOptions = [
    { displayName: "Appraiser", value: "Appraiser" },
    { displayName: "Assessor", value: "Assessor" },
    { displayName: "Builder", value: "Builder" },
    { displayName: "Estimated", value: "Estimated" },
    { displayName: "Other", value: "Other" },
    { displayName: "Owner", value: "Owner" },
    { displayName: "Plans", value: "Plans" },
    { displayName: "Public Records", value: "Public Records" },
    { displayName: "See Remarks", value: "See Remarks" },
]
export const accessibilityFeaturesOptions = [
    { displayName: "Accessible Approach with Ramp", value: "Accessible Approach with Ramp" },
    { displayName: "Accessible Bedroom", value: "Accessible Bedroom" },
    { displayName: "Accessible Central Living Area", value: "Accessible Central Living Area" },
    { displayName: "Accessible Closets", value: "Accessible Closets" },
    { displayName: "Accessible Common Area", value: "Accessible Common Area" },
    { displayName: "Accessible Doors", value: "Accessible Doors" },
    {
        displayName: "Accessible Electrical and Environmental Controls",
        value: "Accessible Electrical and Environmental Controls",
    },
    { displayName: "Accessible Elevator Installed", value: "Accessible Elevator Installed" },
    { displayName: "Accessible Entrance", value: "Accessible Entrance" },
    { displayName: "Accessible for Hearing-Impairment", value: "Accessible for Hearing-Impairment" },
    { displayName: "Accessible Full Bath", value: "Accessible Full Bath" },
    { displayName: "Accessible Hallway(s)", value: "Accessible Hallway(s)" },
    { displayName: "Accessible Kitchen", value: "Accessible Kitchen" },
    { displayName: "Accessible Kitchen Appliances", value: "Accessible Kitchen Appliances" },
    { displayName: "Accessible Stairway", value: "Accessible Stairway" },
    { displayName: "Accessible Washer/Dryer", value: "Accessible Washer/Dryer" },
    { displayName: "Adaptable Bathroom Walls", value: "Adaptable Bathroom Walls" },
    { displayName: "Adaptable For Elevator", value: "Adaptable For Elevator" },
    { displayName: "Ceiling Track", value: "Ceiling Track" },
    { displayName: "Central Living Area", value: "Central Living Area" },
    { displayName: "Common Area", value: "Common Area" },
    { displayName: "Customized Wheelchair Accessible", value: "Customized Wheelchair Accessible" },
    { displayName: "Electronic Environmental Controls", value: "Electronic Environmental Controls" },
    { displayName: "Enhanced Accessible", value: "Enhanced Accessible" },
    { displayName: "Exterior Wheelchair Lift", value: "Exterior Wheelchair Lift" },
    { displayName: "Grip-Accessible Features", value: "Grip-Accessible Features" },
    { displayName: "Reinforced Floors", value: "Reinforced Floors" },
    { displayName: "Safe Emergency Egress from Home", value: "Safe Emergency Egress from Home" },
    { displayName: "Smart Technology", value: "Smart Technology" },
    { displayName: "Stair Lift", value: "Stair Lift" },
    { displayName: "Standby Generator", value: "Standby Generator" },
    { displayName: "Therapeutic Whirlpool", value: "Therapeutic Whirlpool" },
    { displayName: "Visitable", value: "Visitable" },
    { displayName: "Visitor Bathroom", value: "Visitor Bathroom" },
    { displayName: "Walker-Accessible Stairs", value: "Walker-Accessible Stairs" },
]
export const propertyTypeOptions = [
    { displayName: "Business Opportunity", value: "Business Opportunity" },
    { displayName: "Commercial Lease", value: "Commercial Lease" },
    { displayName: "Commercial Sale", value: "Commercial Sale" },
    { displayName: "Farm", value: "Farm" },
    { displayName: "Land", value: "Land" },
    { displayName: "Manufactured In Park", value: "Manufactured In Park" },
    { displayName: "Residential", value: "Residential" },
    { displayName: "Residential Income", value: "Residential Income" },
    { displayName: "Residential Lease", value: "Residential Lease" },
]
export const architecturalStyleOptions = [
    { displayName: "A-Frame", value: "A-Frame" },
    { displayName: "Art Deco", value: "Art Deco" },
    { displayName: "Barndominium", value: "Barndominium" },
    { displayName: "Berm", value: "Berm" },
    { displayName: "Bungalow", value: "Bungalow" },
    { displayName: "Cabin", value: "Cabin" },
    { displayName: "Cape Cod", value: "Cape Cod" },
    { displayName: "Colonial", value: "Colonial" },
    { displayName: "Contemporary", value: "Contemporary" },
    { displayName: "Craftsman", value: "Craftsman" },
    { displayName: "Creole", value: "Creole" },
    { displayName: "Dome", value: "Dome" },
    { displayName: "Dutch Colonial", value: "Dutch Colonial" },
    { displayName: "Farmhouse", value: "Farmhouse" },
    { displayName: "Federal", value: "Federal" },
    { displayName: "French Provincial", value: "French Provincial" },
    { displayName: "Georgian", value: "Georgian" },
    { displayName: "Gothic Revival", value: "Gothic Revival" },
    { displayName: "Greek Revival", value: "Greek Revival" },
    { displayName: "Italianate", value: "Italianate" },
    { displayName: "Mediterranean", value: "Mediterranean" },
    { displayName: "Mid-Century Modern", value: "Mid-Century Modern" },
    { displayName: "Modern", value: "Modern" },
    { displayName: "Monterey", value: "Monterey" },
    { displayName: "National", value: "National" },
    { displayName: "Neoclassical", value: "Neoclassical" },
    { displayName: "Other", value: "Other" },
    { displayName: "Prairie", value: "Prairie" },
    { displayName: "Pueblo", value: "Pueblo" },
    { displayName: "Queen Anne", value: "Queen Anne" },
    { displayName: "Raised Ranch", value: "Raised Ranch" },
    { displayName: "Ranch", value: "Ranch" },
    { displayName: "Regency", value: "Regency" },
    { displayName: "Rustic", value: "Rustic" },
    { displayName: "Saltbox", value: "Saltbox" },
    { displayName: "See Remarks", value: "See Remarks" },
    { displayName: "Shingle", value: "Shingle" },
    { displayName: "Shotgun", value: "Shotgun" },
    { displayName: "Spanish", value: "Spanish" },
    { displayName: "Split Level", value: "Split Level" },
    { displayName: "Stick", value: "Stick" },
    { displayName: "Traditional", value: "Traditional" },
    { displayName: "Tudor", value: "Tudor" },
    { displayName: "Victorian", value: "Victorian" },
]
export const structureTypeOptions = [
    { displayName: "Cabin", value: "Cabin" },
    { displayName: "Dock", value: "Dock" },
    { displayName: "Duplex", value: "Duplex" },
    { displayName: "Flex", value: "Flex" },
    { displayName: "Hotel/Motel", value: "Hotel/Motel" },
    { displayName: "House", value: "House" },
    { displayName: "Industrial", value: "Industrial" },
    { displayName: "Manufactured House", value: "Manufactured House" },
    { displayName: "Mixed Use", value: "Mixed Use" },
    { displayName: "Multi Family", value: "Multi Family" },
    { displayName: "None", value: "None" },
    { displayName: "Office", value: "Office" },
    { displayName: "Quadruplex", value: "Quadruplex" },
    { displayName: "Retail", value: "Retail" },
    { displayName: "Townhouse", value: "Townhouse" },
    { displayName: "Triplex", value: "Triplex" },
    { displayName: "Warehouse", value: "Warehouse" },
]
export const constructionMaterialsOptions = [
    { displayName: "Adobe", value: "Adobe" },
    { displayName: "Aluminum Siding", value: "Aluminum Siding" },
    { displayName: "Asbestos", value: "Asbestos" },
    { displayName: "Asphalt", value: "Asphalt" },
    { displayName: "Attic/Crawl Hatchway(s) Insulated", value: "Attic/Crawl Hatchway(s) Insulated" },
    { displayName: "Batts Insulation", value: "Batts Insulation" },
    { displayName: "Block", value: "Block" },
    { displayName: "Blown-In Insulation", value: "Blown-In Insulation" },
    { displayName: "Board & Batten Siding", value: "Board & Batten Siding" },
    { displayName: "Brick", value: "Brick" },
    { displayName: "Brick Veneer", value: "Brick Veneer" },
    { displayName: "Cedar", value: "Cedar" },
    { displayName: "Cement Siding", value: "Cement Siding" },
    { displayName: "Clapboard", value: "Clapboard" },
    { displayName: "Concrete", value: "Concrete" },
    { displayName: "Ducts Professionally Air-Sealed", value: "Ducts Professionally Air-Sealed" },
    { displayName: "Exterior Duct-Work is Insulated", value: "Exterior Duct-Work is Insulated" },
    { displayName: "Fiber Cement", value: "Fiber Cement" },
    { displayName: "Fiberglass Siding", value: "Fiberglass Siding" },
    { displayName: "Foam Insulation", value: "Foam Insulation" },
    { displayName: "Frame", value: "Frame" },
    { displayName: "Glass", value: "Glass" },
    { displayName: "HardiPlank Type", value: "HardiPlank Type" },
    { displayName: "ICAT Recessed Lighting", value: "ICAT Recessed Lighting" },
    { displayName: "ICFs", value: "ICFs" },
    { displayName: "Lap Siding", value: "Lap Siding" },
    { displayName: "Log", value: "Log" },
    { displayName: "Log Siding", value: "Log Siding" },
    { displayName: "Low VOC Insulation", value: "Low VOC Insulation" },
    { displayName: "Masonite", value: "Masonite" },
    { displayName: "Metal Siding", value: "Metal Siding" },
    { displayName: "Natural Building", value: "Natural Building" },
    { displayName: "Other", value: "Other" },
    { displayName: "Plaster", value: "Plaster" },
    { displayName: "Radiant Barrier", value: "Radiant Barrier" },
    { displayName: "Rammed Earth", value: "Rammed Earth" },
    { displayName: "Recycled/Bio-Based Insulation", value: "Recycled/Bio-Based Insulation" },
    { displayName: "Redwood Siding", value: "Redwood Siding" },
    { displayName: "See Remarks", value: "See Remarks" },
    { displayName: "Shake Siding", value: "Shake Siding" },
    { displayName: "Shingle Siding", value: "Shingle Siding" },
    { displayName: "Slump Block", value: "Slump Block" },
    { displayName: "Spray Foam Insulation", value: "Spray Foam Insulation" },
    { displayName: "Steel Frame", value: "Steel Frame" },
    { displayName: "Steel Siding", value: "Steel Siding" },
    { displayName: "Stone", value: "Stone" },
    { displayName: "Stone Veneer", value: "Stone Veneer" },
    { displayName: "Straw", value: "Straw" },
    { displayName: "Stucco", value: "Stucco" },
    { displayName: "Synthetic Stucco", value: "Synthetic Stucco" },
    { displayName: "Unknown", value: "Unknown" },
    { displayName: "Vertical Siding", value: "Vertical Siding" },
    { displayName: "Vinyl Siding", value: "Vinyl Siding" },
    { displayName: "Wood Siding", value: "Wood Siding" },
]

export const areaUnitsOptions = [
    { displayName: "Feet", value: "Feet" },
    { displayName: "Meters", value: "Meters" },
]

export const mobileDimUnitsOptions = areaUnitsOptions

export const foundationDetailsOptions = [
    { displayName: "Block", value: "Block" },
    { displayName: "Brick/Mortar", value: "Brick/Mortar" },
    { displayName: "Combination", value: "Combination" },
    { displayName: "Concrete Perimeter", value: "Concrete Perimeter" },
    { displayName: "None", value: "None" },
    { displayName: "Other", value: "Other" },
    { displayName: "Permanent", value: "Permanent" },
    { displayName: "Pillar/Post/Pier", value: "Pillar/Post/Pier" },
    { displayName: "Raised", value: "Raised" },
    { displayName: "See Remarks", value: "See Remarks" },
    { displayName: "Slab", value: "Slab" },
    { displayName: "Stone", value: "Stone" },
]

export const roofOptions = [
    { displayName: "Aluminum", value: "Aluminum" },
    { displayName: "Asbestos Shingle", value: "Asbestos Shingle" },
    { displayName: "Asphalt", value: "Asphalt" },
    { displayName: "Bahama", value: "Bahama" },
    { displayName: "Barrel", value: "Barrel" },
    { displayName: "Bituthene", value: "Bituthene" },
    { displayName: "Built-Up", value: "Built-Up" },
    { displayName: "Composition", value: "Composition" },
    { displayName: "Concrete", value: "Concrete" },
    { displayName: "Copper", value: "Copper" },
    { displayName: "Elastomeric", value: "Elastomeric" },
    { displayName: "Fiberglass", value: "Fiberglass" },
    { displayName: "Flat", value: "Flat" },
    { displayName: "Flat Tile", value: "Flat Tile" },
    { displayName: "Foam", value: "Foam" },
    { displayName: "Green Roof", value: "Green Roof" },
    { displayName: "Mansard", value: "Mansard" },
    { displayName: "Membrane", value: "Membrane" },
    { displayName: "Metal", value: "Metal" },
    { displayName: "Mixed", value: "Mixed" },
    { displayName: "None", value: "None" },
    { displayName: "Other", value: "Other" },
    { displayName: "Rolled/Hot Mop", value: "Rolled/Hot Mop" },
    { displayName: "Rubber", value: "Rubber" },
    { displayName: "See Remarks", value: "See Remarks" },
    { displayName: "Shake", value: "Shake" },
    { displayName: "Shingle", value: "Shingle" },
    { displayName: "Slate", value: "Slate" },
    { displayName: "Spanish Tile", value: "Spanish Tile" },
    { displayName: "Stone", value: "Stone" },
    { displayName: "Synthetic", value: "Synthetic" },
    { displayName: "Tar/Gravel", value: "Tar/Gravel" },
    { displayName: "Tile", value: "Tile" },
    { displayName: "Wood", value: "Wood" },
]

export const propertyConditionOptions = [
    { displayName: "Fixer", value: "Fixer" },
    { displayName: "New export construction", value: "New export construction" },
    { displayName: "To Be Built", value: "To Be Built" },
    {
        displayName: "Under export construction (PropertyCondition)",
        value: "Under export construction (PropertyCondition)",
    },
    { displayName: "Updated/Remodeled", value: "Updated/Remodeled" },
]

export const buildingAreaSourceOptions = [
    { displayName: "Appraiser", value: "Appraiser" },
    { displayName: "Assessor", value: "Assessor" },
    { displayName: "Builder", value: "Builder" },
    { displayName: "Estimated", value: "Estimated" },
    { displayName: "Other", value: "Other" },
    { displayName: "Owner", value: "Owner" },
    { displayName: "Plans", value: "Plans" },
    { displayName: "Public Records", value: "Public Records" },
    { displayName: "See Remarks", value: "See Remarks" },
]

export const buildingAreaUnitsOptions = areaUnitsOptions

export const directionFacesOptions = [
    { displayName: "East", value: "East" },
    { displayName: "North", value: "North" },
    { displayName: "Northeast", value: "Northeast" },
    { displayName: "Northwest", value: "Northwest" },
    { displayName: "South", value: "South" },
    { displayName: "Southeast", value: "Southeast" },
    { displayName: "Southwest", value: "Southwest" },
    { displayName: "West", value: "West" },
]

export const electricOptions = [
    { displayName: "100 Amp Service", value: "100 Amp Service" },
    { displayName: "150 Amp Service", value: "150 Amp Service" },
    { displayName: "200+ Amp Service", value: "200+ Amp Service" },
    { displayName: "220 Volts", value: "220 Volts" },
    { displayName: "220 Volts For Spa", value: "220 Volts For Spa" },
    { displayName: "220 Volts in Garage", value: "220 Volts in Garage" },
    { displayName: "220 Volts in Kitchen", value: "220 Volts in Kitchen" },
    { displayName: "220 Volts in Laundry", value: "220 Volts in Laundry" },
    { displayName: "220 Volts in Workshop", value: "220 Volts in Workshop" },
    { displayName: "440 Volts", value: "440 Volts" },
    { displayName: "Circuit Breakers", value: "Circuit Breakers" },
    { displayName: "Energy Storage Device", value: "Energy Storage Device" },
    { displayName: "Fuses", value: "Fuses" },
    { displayName: "Generator", value: "Generator" },
    { displayName: "Net Meter", value: "Net Meter" },
    { displayName: "Pre-Wired for Renewables", value: "Pre-Wired for Renewables" },
    { displayName: "Ready for Renewables", value: "Ready for Renewables" },
    { displayName: "Underground", value: "Underground" },
]
export const roadSurfaceTypeOptions = [
    { displayName: "Alley Paved", value: "Alley Paved" },
    { displayName: "Asphalt", value: "Asphalt" },
    { displayName: "Chip And Seal", value: "Chip And Seal" },
    { displayName: "Concrete", value: "Concrete" },
    { displayName: "Dirt", value: "Dirt" },
    { displayName: "Gravel", value: "Gravel" },
    { displayName: "None", value: "None" },
    { displayName: "Other", value: "Other" },
    { displayName: "Paved", value: "Paved" },
    { displayName: "See Remarks", value: "See Remarks" },
    { displayName: "Unimproved", value: "Unimproved" },
]

export const rentIncludesOptions = [
    { displayName: "All Utilities", value: "All Utilities" },
    { displayName: "Cable TV", value: "Cable TV" },
    { displayName: "Electricity", value: "Electricity" },
    { displayName: "Gardener", value: "Gardener" },
    { displayName: "Gas", value: "Gas" },
    { displayName: "Internet", value: "Internet" },
    { displayName: "Management", value: "Management" },
    { displayName: "None", value: "None" },
    { displayName: "Other", value: "Other" },
    { displayName: "See Remarks", value: "See Remarks" },
    { displayName: "Sewer", value: "Sewer" },
    { displayName: "Trash Collection", value: "Trash Collection" },
    { displayName: "Water", value: "Water" },
]

export const sewerOptions = [
    { displayName: "Aerobic Septic", value: "Aerobic Septic" },
    { displayName: "Cesspool", value: "Cesspool" },
    { displayName: "Engineered Septic", value: "Engineered Septic" },
    { displayName: "Holding Tank", value: "Holding Tank" },
    { displayName: "Mound Septic", value: "Mound Septic" },
    { displayName: "None", value: "None" },
    { displayName: "Other", value: "Other" },
    { displayName: "Perc Test On File", value: "Perc Test On File" },
    { displayName: "Perc Test Required", value: "Perc Test Required" },
    { displayName: "Private Sewer", value: "Private Sewer" },
    { displayName: "Public Sewer", value: "Public Sewer" },
    { displayName: "Septic Needed", value: "Septic Needed" },
    { displayName: "Septic Tank", value: "Septic Tank" },
    { displayName: "Shared Septic", value: "Shared Septic" },
    { displayName: "Unknown", value: "Unknown" },
]
export const utilitiesOptions = [
    { displayName: "Cable Available", value: "Cable Available" },
    { displayName: "Cable Connected", value: "Cable Connected" },
    { displayName: "Cable Not Available", value: "Cable Not Available" },
    { displayName: "Electricity Available", value: "Electricity Available" },
    { displayName: "Electricity Connected", value: "Electricity Connected" },
    { displayName: "Electricity Not Available", value: "Electricity Not Available" },
    { displayName: "Natural Gas Available", value: "Natural Gas Available" },
    { displayName: "Natural Gas Connected", value: "Natural Gas Connected" },
    { displayName: "Natural Gas Not Available", value: "Natural Gas Not Available" },
    { displayName: "None", value: "None" },
    { displayName: "Other", value: "Other" },
    { displayName: "Phone Available", value: "Phone Available" },
    { displayName: "Phone Connected", value: "Phone Connected" },
    { displayName: "Phone Not Available", value: "Phone Not Available" },
    { displayName: "Propane", value: "Propane" },
    { displayName: "See Remarks", value: "See Remarks" },
    { displayName: "Sewer Available", value: "Sewer Available" },
    { displayName: "Sewer Connected", value: "Sewer Connected" },
    { displayName: "Sewer Not Available", value: "Sewer Not Available" },
    { displayName: "Underground Utilities", value: "Underground Utilities" },
    { displayName: "Water Available", value: "Water Available" },
    { displayName: "Water Connected", value: "Water Connected" },
    { displayName: "Water Not Available", value: "Water Not Available" },
]
export const waterSourceOptions = [
    { displayName: "Cistern", value: "Cistern" },
    { displayName: "None", value: "None" },
    { displayName: "Other", value: "Other" },
    { displayName: "Private", value: "Private" },
    { displayName: "Public", value: "Public" },
    { displayName: "See Remarks", value: "See Remarks" },
    { displayName: "Shared Well", value: "Shared Well" },
    { displayName: "Spring", value: "Spring" },
    { displayName: "Well", value: "Well" },
]
export const greenIndoorAirQualityOptions = [
    { displayName: "Contaminant Control", value: "Contaminant Control" },
    { displayName: "Integrated Pest Management", value: "Integrated Pest Management" },
    { displayName: "Moisture Control", value: "Moisture Control" },
    { displayName: "Ventilation", value: "Ventilation" },
]
export const greenEnergyGenerationOptions = [
    { displayName: "Solar", value: "Solar" },
    { displayName: "Wind", value: "Wind" },
]
export const greenSustainabilityOptions = [
    { displayName: "Conserving Methods", value: "Conserving Methods" },
    { displayName: "Onsite Recycling Center", value: "Onsite Recycling Center" },
    { displayName: "Recyclable Materials", value: "Recyclable Materials" },
    { displayName: "Recycled Materials", value: "Recycled Materials" },
    { displayName: "Regionally-Sourced Materials", value: "Regionally-Sourced Materials" },
    { displayName: "Renewable Materials", value: "Renewable Materials" },
    { displayName: "Salvaged Materials", value: "Salvaged Materials" },
]
export const greenWaterConservationOptions = [
    { displayName: "Efficient Hot Water Distribution", value: "Efficient Hot Water Distribution" },
    { displayName: "Gray Water System", value: "Gray Water System" },
    { displayName: "Green Infrastructure", value: "Green Infrastructure" },
    { displayName: "Low-Flow Fixtures", value: "Low-Flow Fixtures" },
    { displayName: "Water Recycling", value: "Water Recycling" },
    { displayName: "Water-Smart Landscaping", value: "Water-Smart Landscaping" },
]
export const booleanOptions = [
    { displayName: "Yes", value: true },
    { displayName: "No", value: false },
]

export const DNDOptions = [
    { displayName: "is enabled", value: true },
    { displayName: "is not enabled", value: false },
]

export const statusOptions = [
    { displayName: "Pending", value: "pending" },
    { displayName: "Completed", value: "completed" },
]

export const standardStatusOptions = [
    { displayName: "Active", value: "Active" },
    { displayName: "Active Under Contract", value: "Active Under Contract" },
]

export const poolFeaturesOptions = [
    { displayName: "Above Ground", value: "Above Ground" },
    { displayName: "Association", value: "Association" },
    { displayName: "Black Bottom", value: "Black Bottom" },
    { displayName: "Cabana", value: "Cabana" },
    { displayName: "Community", value: "Community" },
    { displayName: "Diving Board", value: "Diving Board" },
    { displayName: "Electric Heat", value: "Electric Heat" },
    { displayName: "ENERGY STAR Qualified pool pump", value: "ENERGY STAR Qualified pool pump" },
    { displayName: "Fenced", value: "Fenced" },
    { displayName: "Fiberglass", value: "Fiberglass" },
    { displayName: "Filtered", value: "Filtered" },
    { displayName: "Gas Heat", value: "Gas Heat" },
    { displayName: "Gunite", value: "Gunite" },
    { displayName: "Heated", value: "Heated" },
    { displayName: "Indoor", value: "Indoor" },
    { displayName: "Infinity", value: "Infinity" },
    { displayName: "In Ground", value: "In Ground" },
    { displayName: "Lap", value: "Lap" },
    { displayName: "Liner", value: "Liner" },
    { displayName: "None", value: "None" },
    { displayName: "Other", value: "Other" },
    { displayName: "Outdoor Pool", value: "Outdoor Pool" },
    { displayName: "Pool/Spa Combo", value: "Pool/Spa Combo" },
    { displayName: "Pool Cover", value: "Pool Cover" },
    { displayName: "Pool Sweep", value: "Pool Sweep" },
    { displayName: "Private", value: "Private" },
    { displayName: "Salt Water", value: "Salt Water" },
    { displayName: "Screen Enclosure", value: "Screen Enclosure" },
    { displayName: "See Remarks", value: "See Remarks" },
    { displayName: "Solar Cover", value: "Solar Cover" },
    { displayName: "Solar Heat", value: "Solar Heat" },
    { displayName: "Sport", value: "Sport" },
    { displayName: "Tile", value: "Tile" },
    { displayName: "Vinyl", value: "Vinyl" },
    { displayName: "Waterfall", value: "Waterfall" },
]

export const communityFeaturesOptions = [
    { displayName: "Airport/Runway", value: "Airport/Runway" },
    { displayName: "Clubhouse", value: "Clubhouse" },
    { displayName: "Curbs", value: "Curbs" },
    { displayName: "Fishing", value: "Fishing" },
    { displayName: "Fitness Center", value: "Fitness Center" },
    { displayName: "Gated", value: "Gated" },
    { displayName: "Golf", value: "Golf" },
    { displayName: "Lake", value: "Lake" },
    { displayName: "None", value: "None" },
    { displayName: "Other", value: "Other" },
    { displayName: "Park", value: "Park" },
    { displayName: "Pickleball", value: "Pickleball" },
    { displayName: "Playground", value: "Playground" },
    { displayName: "Pool", value: "Pool" },
    { displayName: "Racquetball", value: "Racquetball" },
    { displayName: "Restaurant", value: "Restaurant" },
    { displayName: "Sidewalks", value: "Sidewalks" },
    { displayName: "Stable(s)", value: "Stable(s)" },
    { displayName: "Street Lights", value: "Street Lights" },
    { displayName: "Suburban", value: "Suburban" },
    { displayName: "Tennis Court(s)", value: "Tennis Court(s)" },
]

export const associationAmenitiesOptions = [
    { displayName: "Airport/Runway", value: "Airport/Runway" },
    { displayName: "Barbecue", value: "Barbecue" },
    { displayName: "Basketball Court", value: "Basketball Court" },
    { displayName: "Beach Access", value: "Beach Access" },
    { displayName: "Beach Rights", value: "Beach Rights" },
    { displayName: "Billiard Room", value: "Billiard Room" },
    { displayName: "Boat Dock", value: "Boat Dock" },
    { displayName: "Boating", value: "Boating" },
    { displayName: "Boat Slip", value: "Boat Slip" },
    { displayName: "Cabana", value: "Cabana" },
    { displayName: "Cable TV", value: "Cable TV" },
    { displayName: "Car Wash Area", value: "Car Wash Area" },
    { displayName: "Clubhouse", value: "Clubhouse" },
    { displayName: "Coin Laundry", value: "Coin Laundry" },
    { displayName: "Concierge", value: "Concierge" },
    { displayName: "Day Care", value: "Day Care" },
    { displayName: "Dog Park", value: "Dog Park" },
    { displayName: "Dry Dock", value: "Dry Dock" },
    { displayName: "Electricity", value: "Electricity" },
    { displayName: "Elevator(s)", value: "Elevator(s)" },
    { displayName: "Exercise Course", value: "Exercise Course" },
    { displayName: "Fitness Center", value: "Fitness Center" },
    { displayName: "Game Court Exterior", value: "Game Court Exterior" },
    { displayName: "Game Court Interior", value: "Game Court Interior" },
    { displayName: "Game Room", value: "Game Room" },
    { displayName: "Gas", value: "Gas" },
    { displayName: "Gated", value: "Gated" },
    { displayName: "Golf Course", value: "Golf Course" },
    { displayName: "Hot Water", value: "Hot Water" },
    { displayName: "Indoor Pool", value: "Indoor Pool" },
    { displayName: "Insurance", value: "Insurance" },
    { displayName: "Jogging Path", value: "Jogging Path" },
    { displayName: "Landscaping", value: "Landscaping" },
    { displayName: "Laundry", value: "Laundry" },
    { displayName: "Maid service", value: "Maid service" },
    { displayName: "Maintenance", value: "Maintenance" },
    { displayName: "Maintenance Grounds", value: "Maintenance Grounds" },
    { displayName: "Maintenance Structure", value: "Maintenance Structure" },
    { displayName: "Management", value: "Management" },
    { displayName: "Marina", value: "Marina" },
    { displayName: "Meeting Room", value: "Meeting Room" },
    { displayName: "None", value: "None" },
    { displayName: "Other", value: "Other" },
    { displayName: "Park", value: "Park" },
    { displayName: "Parking", value: "Parking" },
    { displayName: "Party Room", value: "Party Room" },
    { displayName: "Picnic Area", value: "Picnic Area" },
    { displayName: "Playground", value: "Playground" },
    { displayName: "Pond Seasonal", value: "Pond Seasonal" },
    { displayName: "Pond Year Round", value: "Pond Year Round" },
    { displayName: "Pool", value: "Pool" },
    { displayName: "Powered Boats Allowed", value: "Powered Boats Allowed" },
    { displayName: "Racquetball", value: "Racquetball" },
    { displayName: "Recreation Facilities", value: "Recreation Facilities" },
    { displayName: "Recreation Room", value: "Recreation Room" },
    { displayName: "Roof Deck", value: "Roof Deck" },
    { displayName: "RV/Boat Storage", value: "RV/Boat Storage" },
    { displayName: "RV Parking", value: "RV Parking" },
    { displayName: "Sauna", value: "Sauna" },
    { displayName: "Security", value: "Security" },
    { displayName: "Service Elevator(s)", value: "Service Elevator(s)" },
    { displayName: "Shuffleboard Court", value: "Shuffleboard Court" },
    { displayName: "Ski Accessible", value: "Ski Accessible" },
    { displayName: "Snow Removal", value: "Snow Removal" },
    { displayName: "Spa/Hot Tub", value: "Spa/Hot Tub" },
    { displayName: "Sport Court", value: "Sport Court" },
    { displayName: "Stable(s)", value: "Stable(s)" },
    { displayName: "Storage", value: "Storage" },
    { displayName: "Stream Seasonal", value: "Stream Seasonal" },
    { displayName: "Stream Year Round", value: "Stream Year Round" },
    { displayName: "Taxes", value: "Taxes" },
    { displayName: "Tennis Court(s)", value: "Tennis Court(s)" },
    { displayName: "Trail(s)", value: "Trail(s)" },
    { displayName: "Trash", value: "Trash" },
    { displayName: "Water", value: "Water" },
    { displayName: "Workshop Area", value: "Workshop Area" },
]

export const ownerPaysOptions = [
    { displayName: "All Utilities", value: "All Utilities" },
    { displayName: "Association Fees", value: "Association Fees" },
    { displayName: "Cable TV", value: "Cable TV" },
    { displayName: "Common Area Maintenance", value: "Common Area Maintenance" },
    { displayName: "Electricity", value: "Electricity" },
    { displayName: "Exterior Maintenance", value: "Exterior Maintenance" },
    { displayName: "Gas", value: "Gas" },
    { displayName: "Grounds Care", value: "Grounds Care" },
    { displayName: "Hot Water", value: "Hot Water" },
    { displayName: "HVAC Maintenance", value: "HVAC Maintenance" },
    { displayName: "Insurance", value: "Insurance" },
    { displayName: "Janitorial Service", value: "Janitorial Service" },
    { displayName: "Management", value: "Management" },
    { displayName: "None", value: "None" },
    { displayName: "Other", value: "Other" },
    { displayName: "Other Tax", value: "Other Tax" },
    { displayName: "Parking Fee", value: "Parking Fee" },
    { displayName: "Pest Control", value: "Pest Control" },
    { displayName: "Pool Maintenance", value: "Pool Maintenance" },
    { displayName: "Repairs", value: "Repairs" },
    { displayName: "Roof Maintenance", value: "Roof Maintenance" },
    { displayName: "Security", value: "Security" },
    { displayName: "See Remarks", value: "See Remarks" },
    { displayName: "Sewer", value: "Sewer" },
    { displayName: "Snow Removal", value: "Snow Removal" },
    { displayName: "Taxes", value: "Taxes" },
    { displayName: "Telephone", value: "Telephone" },
    { displayName: "Trash Collection", value: "Trash Collection" },
    { displayName: "Water", value: "Water" },
]

export const workflowStatusOptions = [
    { displayName: "On", value: "on" },
    { displayName: "Off", value: "off" },
    { displayName: "Unpublished", value: "unpublished" },
]

export const levelOptions = [
    { displayName: "Info", value: "info" },
    { displayName: "Warn", value: "warn" },
    { displayName: "Error", value: "error" },
]

export const agentStatusOptions = [
    { displayName: "Active", value: "active" },
    { displayName: "Pending", value: "pending" },
    { displayName: "Disabled", value: "disabled" },
]

export const inviteStatusOptions = [
    { displayName: "Accepted", value: "accepted" },
    { displayName: "Pending", value: "pending" },
]

export const logStatusOptions = [
    { displayName: "Open", value: "open" },
    { displayName: "Resolved", value: "resolved" },
    { displayName: "In Progress", value: "inProgress" },
]

export const shouldRemoveOptions = [
    { displayName: "Yes", value: "true" },
    { displayName: "No", value: "false" },
]

export const reminderOptions = [
    { displayName: "30 Minutes Before", value: "minutes_30" },
    { displayName: "1 Hour Before", value: "hours_1" },
    { displayName: "1 Day Before", value: "days_1" },
    { displayName: "1 Week Before", value: "weeks_1" },
]

export const createdAtOptions = [
    { displayName: "Last 24 hours", value: "__last_24_days__" },
    { displayName: "Last 3 days", value: "__last_3_days__" },
    { displayName: "Last 7 days", value: "__last_7_days__" },
    { displayName: "Last 14 days", value: "__last_14_days__" },
    { displayName: "Last 30 days", value: "__last_30_days__" },
]

export const listingTermOptions = [
    { displayName: "1031 Exchange", value: "1031 Exchange" },
    { displayName: "All Inclusive Trust Deed", value: "All Inclusive Trust Deed" },
    { displayName: "Assumable", value: "Assumable" },
    { displayName: "Cash", value: "Cash" },
    { displayName: "Contract", value: "Contract" },
    { displayName: "Conventional", value: "Conventional" },
    { displayName: "Existing Bonds", value: "Existing Bonds" },
    { displayName: "FHA", value: "FHA" },
    { displayName: "Land Use Fee", value: "Land Use Fee" },
    { displayName: "Lease Back", value: "Lease Back" },
    { displayName: "Lease Option", value: "Lease Option" },
    { displayName: "Lease Purchase", value: "Lease Purchase" },
    { displayName: "Lien Release", value: "Lien Release" },
    { displayName: "Owner May Carry", value: "Owner May Carry" },
    { displayName: "Owner Pay Points", value: "Owner Pay Points" },
    { displayName: "Owner Will Carry", value: "Owner Will Carry" },
    { displayName: "Private Financing Available", value: "Private Financing Available" },
    { displayName: "Relocation Property", value: "Relocation Property" },
    { displayName: "Seller Equity Share", value: "Seller Equity Share" },
    { displayName: "Special Funding", value: "Special Funding" },
    { displayName: "Submit", value: "Submit" },
    { displayName: "Trade", value: "Trade" },
    { displayName: "Trust Conveyance", value: "Trust Conveyance" },
    { displayName: "Trust Deed", value: "Trust Deed" },
    { displayName: "USDA Loan", value: "USDA Loan" },
    { displayName: "VA Loan", value: "VA Loan" },
]

export const onMarketTimestampOptions = [
    { displayName: "Last 24 hours", value: "__last_24_days__" },
    { displayName: "Last 3 days", value: "__last_3_days__" },
    { displayName: "Last 7 days", value: "__last_7_days__" },
    { displayName: "Last 14 days", value: "__last_14_days__" },
    { displayName: "Last 30 days", value: "__last_30_days__" },
]

export const itemTypesOptions = [
    { displayName: "Email", value: "EmailMessagingThread" },
    { displayName: "Text Message", value: "SMSMessagingThread" },
    { displayName: "Call", value: "Call" },
]

export const furnishedOptions = [
    { displayName: "Furnished", value: "Furnished" },
    { displayName: "Negotiable", value: "Negotiable" },
    { displayName: "Partially", value: "Partially" },
    { displayName: "Unfurnished", value: "Unfurnished" },
]

export const stateOptions = [
    { displayName: "Published", value: "Published" },
    { displayName: "Draft", value: "Draft" },
]

export const roleOptions = [
    { displayName: "Owner", value: "owner" },
    { displayName: "Member", value: "member" },
]

export const visiblityOptions = [
    { displayName: "Visible", value: "Visible" },
    { displayName: "Hidden", value: "Hidden" },
]

export const lockedOptions = [
    { displayName: "Unlocked", value: "Unlocked" },
    { displayName: "Locked", value: "Locked" },
]

export const usagesOptions = [
    { displayName: "In Use", value: "In Use" },
    { displayName: "Not Used", value: "Not Used" },
]
